module.exports = __webpack_public_path__ + "static/img/hb_10-min.6b2fdc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_10-min.png
// module id = sgMU
// module chunks = 1